import { shape, string, arrayOf, func, oneOfType } from 'prop-types';

export const reportConfig = shape({
  jasperServer: string,
  onError: func,
  onSuccess: func,
  reportRoot: string,
  token: oneOfType([arrayOf(string), string]),
});
